import React, { Fragment } from 'react'
import { Page, Text, View, Document, StyleSheet, Image, Link, Font } from '@react-pdf/renderer';
import { calculateProductCosts, capitalizeFirstLetter, count, dateConverter, getBrands, getCustomerPaymentStatus, isDefined, money, replaceStringWith } from '../../../../config/helpers';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import dayjs from 'dayjs';
import { getNextApi } from 'utils/requestHelpers';
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
    ]
});

const styles = StyleSheet.create({
    body: {
        fontSize: '8px',
        padding: '30px',
        paddingBottom: 65,
        fontFamily: 'Open Sans',
    },
    image: {
        objectFit: 'contain'
    },
    header: {
        fontSize: '14px',
        fontWeight: 'bold',
    },
    header_2: {
        fontSize: '12px',
        fontWeight: 1000,
    },
    header_3: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'red'
    },
    bold: {
        fontWeight: 1000,
    },
    red: {
        color: 'red',
    },
    rowPaddimg: {
        paddingLeft: 8,
        paddingRight: 8,
    },
    content: {
        display: 'flex',
        fontSize: '8px',
        justifyContent: 'space-between',
        '@media max-width: 400': {
            flexDirection: 'column',
        },
        '@media min-width: 400': {
            flexDirection: 'row',
        },
    },
    content_top: {
        display: 'flex',
        fontSize: '8px',
        justifyContent: 'space-between',
        '@media max-width: 400': {
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        '@media min-width: 400': {
            flexDirection: 'row',
        },
    },
    block: {
        // border: '1px dotted black',
        width: '100%',
        // padding: '5px',
        marginTop: '4px',
        marginBottom: '4px'
    },
    rowViewProducts: {
        display: 'flex', flexDirection: 'row', width: '100%'
    },
    rowView: {
        display: 'flex', flexDirection: 'row', textAlign: "left", width: '75%', paddingTop: '1px', paddingBottom: '1px'
    },
    rowView_col: {
        display: 'flex', flexDirection: 'row', textAlign: "left", width: '25%'
    },
    rowView_title: {
        display: 'flex', flexDirection: 'row', textAlign: "left", width: '40%'
    },
    link: {
        color: '#0d6efd',
        textDecoration: 'underline'
    },
    pageNumber: {
        padding: '10px',
        position: 'absolute',
        fontSize: 10,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'end',
    },

    table: {
        width: '100%',
        // padding: '9px'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        // borderBottom: '1px solid #EEE',
        paddingTop: 2,
        paddingBottom: 22,
    },
    rowLeft: {
        display: 'flex',
        flexDirection: 'row',
        // borderBottom: '1px solid #EEE',
        paddingTop: 2,
        paddingBottom: 4,
    },
    header_table: {
        borderTop: 'none',
        paddingBottom: 2
    },
    bold_table: {
        fontWeight: 'bold',
    },

    order_items: {
        image: {
            width: '7.5%',
            display: 'flex',
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        description: {
            width: '52.5%',
            paddingRight: '5px',
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        qty: {
            paddingLeft: '5px',
            width: '10%',
            marginTop: 'auto',
            marginBottom: 'auto',
            textAlign: 'right',
        },
        billed_weeks: {
            paddingLeft: '5px',
            width: '10%',
            marginTop: 'auto',
            marginBottom: 'auto',
            textAlign: 'right',
        },
        unit_price: {
            width: '10%',
            textAlign: 'right',
            marginTop: 'auto',
            marginBottom: 'auto',
        },
        amount: {
            width: '10%',
            textAlign: 'right',
            marginTop: 'auto',
            marginBottom: 'auto',
        },


        left: {
            width: '80%',
        },
        right: {
            width: '20%',
            textAlign: 'right'
        },
    }

});

const HNS_COL = '#f2f2f2';


const QuotePDFDoc = ({ Obj, type, brand_data, existing, mandatoryService = false, showBilling = true, hide_product_images = false }) => {

    const BrandData = brand_data;
    const CARRIAGE_COL = brand_data.breakdown_hex;
    const payment_status = getCustomerPaymentStatus(Obj.details.PaymentReceived, Obj.details.PaymentReference, Obj.details.PaymentMethod, Obj.details.PaymentDate, Obj.details.PaymentTerms, Obj.details.POReference, {
        stripe_reference: Obj.details.PaymentReference,
        purchase_order: Obj.details.POReference,
    })

    const hasPartialPayment = () => {
        if (Obj?.details?.total_paid == null || Obj?.details?.total_paid == 0 || Obj?.details?.total_paid == "") {
            return false;
        }

        else if (Obj?.details.total_paid > 0 && (Obj?.details?.total_paid - Obj?.details?.payment_amount != 0)) {
            return true;
        }
        return false;
    }

    const is_proforma = (Obj?.details?.Proforma && Number(Obj.details.Proforma) == 1);


    const QuoteLabel = () => {
        if (type == 'order') return '';

        else {
            const isMultiQuote = Obj?.details?.MultiQuote == 1;
            const hasVariants = Obj?.variants?.length > 0;
            const variant = Obj?.variants?.find(variant => variant.quote_variant_quote_id == Obj.details.QuoteID);
            if (isMultiQuote == 1 && hasVariants) {
                return ` - ${variant.quote_variant_label}`;
            }
            return '';
        }

    }

    const invoiceTable = () => {

        const rows = [
            'title',
            'content'
        ];

        const data = [
            {
                title: 'Customer ID',
                content: Obj.details.CustomerID
            },
            {
                title: `${type == 'order' ? 'Invoice' : 'Quote'} Reference`,
                content: `${Obj.details[`${capitalizeFirstLetter(type)}ID`]}`
            },
            {
                title: `${type == 'order' ? 'Invoice' : 'Quote'} Date`,
                content: dayjs(Obj.details[`US${capitalizeFirstLetter(type)}Date`]).format('DD/MM/YYYY')
            },
        ]

        if (type == 'order') {
            if (is_proforma == false && Obj?.details?.VATDate) {
                data.push(
                    {
                        title: 'Tax Date',
                        content: dayjs(Obj.details.VATDate).format('DD/MM/YYYY'),
                    }
                )
            }
        }
        else if (type == 'quote') {

        }

        data.push(
            {
                title: 'Payment Terms',
                content: <Text style={{ color: payment_status.hex_code }}>{payment_status.message_PDF}</Text>
            },
            {
                title: 'Contact',
                content: Obj?.details?.Agent || '-'
            },
        )

        if (Obj?.details?.POReference) {
            data.push(
                {
                    title: 'PO Reference',
                    content: Obj?.details?.POReference
                },
            )
        }

        return (
            <>
                {data.map((rowData, idx) =>
                    <View key={idx} style={styles.rowView}>
                        {rows.map((c, c_idx) =>
                            <Text key={c_idx} style={{ width: `${100 / 2}%`, ...styles.bold }}>
                                {!isDefined(rowData[c]) || !rowData[c] || rowData[c] == "" || rowData[c] == 'XXXXX' ? (
                                    'N/A'
                                ) : rowData[c]}
                            </Text>
                        )}
                    </View>
                )}
            </>
        )
    }

    const isAddressTheSame = (address_1, address_2) => {
        let address_1_copy = { ...address_1 };
        let address_2_copy = { ...address_2 };

        delete address_1_copy['modified'];
        delete address_1_copy['newAddress'];

        delete address_2_copy['modified'];
        delete address_2_copy['newAddress'];

        // console.log(address_1_copy, address_2_copy)


        return JSON.stringify(address_1_copy) == JSON.stringify(address_2_copy);
    }

    const isValidRow = (val) => {
        return typeof val != 'undefined' && val != null && val != "";
    }

    const billToTable = () => {

        const rows = [
            'title',
        ];

        const billing = Obj.addresses.billing;
        const delivery = Obj.addresses.delivery;
        const collection = Obj.addresses.collection;

        const data = {
            billing: [
                { title: billing.CompanyName },
                { title: billing.ContactName },
                { title: billing.Address1 },
                { title: billing.Address2 },
                { title: billing.Town },
                // { title: billing.County },
                { title: billing.PostCode },
                { title: billing.Country },
                {
                    title: showBilling ? Obj.details.EmailAddress : ''
                }
            ],
            delivery: [
                { title: delivery.CompanyName },
                { title: delivery.ContactName },
                { title: delivery.Address1 },
                { title: delivery.Address2 },
                { title: delivery.Town },
                // { title: delivery.County },
                { title: delivery.PostCode },
                { title: delivery.Country },
                { title: Obj.details.EmailAddress },
            ],
            collection: [
                { title: collection.CompanyName },
                { title: collection.ContactName },
                { title: collection.Address1 },
                { title: collection.Address2 },
                { title: collection.Town },
                // { title: collection.County },
                { title: collection.PostCode },
                { title: collection.Country },
                { title: Obj.details.EmailAddress },
            ],

        }

        const billing_address_id = Obj.addresses.billing.address_id;
        const delivery_address_id = Obj.addresses.delivery.address_id;
        const collection_address_id = Obj.addresses.collection.address_id;
        let singleAddress = false;
        let delivery_and_collection_same = false;
        let columns = 1;

        if (
            isAddressTheSame(billing, delivery) &&
            isAddressTheSame(billing, collection)
        ) {
            singleAddress = true;
            columns = 1;
        }
        else if (isAddressTheSame(delivery, collection)) {
            delivery_and_collection_same = true;
            columns = 2;
        }
        else {
            columns = 3;
        }

        return (
            <>
                <View style={{ ...styles.content, marginTop: '10px', columns: columns }}>
                    <View style={{ ...styles.block, width: '100%' }}>
                        <View style={styles.rowView}>
                            <Text style={{ width: `100%`, fontWeight: 'bold' }}>{singleAddress ? 'Bill to / Delivery to / Collection from' : 'Bill to'}</Text>
                        </View>

                        {data['billing'].map((rowData, idx) =>
                            <Fragment key={idx}>
                                {rows.map((c, c_index) => (
                                    <Fragment key={c_index} >
                                        {isValidRow(rowData[c]) ? <Text style={{ width: `100%` }}>{rowData[c].trim()}</Text> : null}
                                    </Fragment>
                                )
                                )}
                            </Fragment>
                        )}
                    </View>
                    {!singleAddress && delivery_and_collection_same ? (
                        <>
                            <View style={{ ...styles.block, width: '100%' }}>
                                <View style={styles.rowView}>
                                    <Text style={{ width: `100%`, fontWeight: 'bold' }}>Delivery to / Collection from</Text>
                                </View>

                                {data['delivery'].map((rowData, idx) =>
                                    <Fragment key={idx}>
                                        {rows.map((c, c_index) => (
                                            <Fragment key={c_index}>
                                                {isValidRow(rowData[c]) ? <Text style={{ width: `100%` }}>{rowData[c].trim()}</Text> : null}
                                            </Fragment>
                                        )
                                        )}
                                    </Fragment>
                                )}
                            </View>

                        </>

                    ) : !singleAddress && !delivery_and_collection_same ? (
                        <>
                            <View style={{ ...styles.block, width: '100%' }}>
                                <View style={styles.rowView}>
                                    <Text style={{ width: `100%`, fontWeight: 'bold' }}>Delivery to</Text>
                                </View>

                                {data['delivery'].map((rowData, idx) =>
                                    <Fragment key={idx}>
                                        {rows.map((c, c_index) => (
                                            <Fragment key={c_index}>
                                                {isValidRow(rowData[c]) ? <Text style={{ width: `100%` }}>{rowData[c].trim()}</Text> : null}
                                            </Fragment>
                                        )
                                        )}
                                    </Fragment>
                                )}
                            </View>

                            <View style={{ ...styles.block, width: '100%' }}>
                                <View style={styles.rowView}>
                                    <Text style={{ width: `100%`, fontWeight: 'bold' }}>Collection from</Text>
                                </View>

                                {data['collection'].map((rowData, idx) =>
                                    <Fragment key={idx}>
                                        {rows.map((c, c_index) => (
                                            <Fragment key={c_index}>
                                                {isValidRow(rowData[c]) ? <Text style={{ width: `100%` }}>{rowData[c].trim()}</Text> : null}
                                            </Fragment>
                                        )
                                        )}
                                    </Fragment>
                                )}
                            </View>
                        </>

                    ) : null}
                </View>

            </>

        )
    }

    const renderBankDetails = () => {

        const rows = [
            'title',
            'content',
        ];


        const data = [
            {
                title: 'Name',
                content: BrandData.CompanyNameOffice
            },
            {
                title: 'Sort Code',
                content: BrandData.SortCode
            },
            {
                title: 'Account Number',
                content: BrandData.AccountNumber
            },
            {
                title: 'Bank',
                content: BrandData.BankName
            },
            {
                title: 'Currency',
                content: BrandData.Currency
            },
            {
                title: 'IBAN',
                content: BrandData.IBAN
            },
            {
                title: 'SWIFT',
                content: BrandData.Swift
            },

        ]


        return (
            <>
                <View>
                    {
                        dayjs().isSameOrAfter(dayjs('2026-07-31')) ? (
                            <Text style={styles.header_3}>
                                Please Note Our New Bank Details
                            </Text>
                        ) : (
                            <Text>
                                Bank Details
                            </Text>
                        )
                    }
                    <Text>
                        Name <Text style={styles.bold}>{BrandData.CompanyNameOffice}</Text>&nbsp;&nbsp;&nbsp; Sort Code <Text style={styles.bold}>{BrandData.SortCode}</Text>&nbsp;&nbsp;&nbsp; Account Number <Text style={styles.bold}>{BrandData.AccountNumber}</Text>
                    </Text>
                    <Text>
                        Bank <Text style={styles.bold}>{BrandData.BankName}</Text>&nbsp;&nbsp;&nbsp; Currency <Text style={styles.bold}>{BrandData.Currency}</Text>&nbsp;&nbsp;&nbsp; IBAN <Text style={styles.bold}>{BrandData.IBAN}</Text>&nbsp;&nbsp;&nbsp;Swift <Text style={styles.bold}>{BrandData.Swift}</Text>
                    </Text>
                </View>
                {/* <View style={styles.rowView_title}>
                    <Text style={{width: `100%`, paddingBottom: '2px'}}>Bank Details</Text>
                </View>
                {data.map((rowData, idx) => 
                    <View key={idx} style={{paddingBottom: '2px'}}>
                        <Text>{`${rowData.title}:`} <Text style={{...styles.bold}}>{`${rowData.content}`}</Text>
                        
                        </Text>
                    </View>
                )} */}
            </>
        )
    }

    const renderTableHeadings = () => {
        return (
            <>
                <View style={[styles.row, styles.bold_table, styles.header_table]}>
                    <Text style={[styles.order_items.image]}>
                        <Text></Text>
                    </Text>
                    <Text style={[styles.order_items.description]}>
                        <Text>Description</Text>
                    </Text>
                    <Text style={[styles.order_items.unit_price]}>
                        <Text>Unit Price</Text>
                    </Text>
                    <Text style={[styles.order_items.qty]}>
                        <Text>Qty</Text>
                    </Text>
                    <Text style={[styles.order_items.billed_weeks]}>
                        <Text>Weeks</Text>
                    </Text>
                    <Text style={[styles.order_items.amount]}>
                        <Text>Total</Text>
                    </Text>
                </View>
            </>
        )
    }

    const renderTableProducts = () => {
        return (
            <>
                {Obj.order_items.map((row, i) => (
                    <View key={i} style={{ ...styles.row, paddingBottom: 0, paddingTop: i == 0 ? 3 : 1 }} wrap={false}>
                        <Text style={[styles.order_items.image]}>
                            {!hide_product_images && (
                                <Image
                                    src={getNextApi(`proxy-image?url=${encodeURIComponent(row.thumbnail)}`)}
                                    style={{ height: '30px', width: '30px' }}
                                />
                            )}
                        </Text>
                        <Text style={[styles.order_items.description]}>
                            <Text>
                                {`${row.ProductTitle} (${row.ProductCodeShort})`}
                                {row?.mandatory_service == 'yes' && mandatoryService && <Text style={{ color: 'red', fontWeight: 'bold' }}>&nbsp;(M)</Text>}
                            </Text>
                        </Text>
                        <Text style={[styles.order_items.unit_price]}>
                            <Text>
                                {`${money(row.UnitPrice)}`}
                            </Text>
                        </Text>
                        <Text style={[styles.order_items.qty]}>
                            <Text>{`${row.Quantity}`}</Text>
                        </Text>
                        <Text style={[styles.order_items.billed_weeks]}>
                            <Text>{`${row.BilledWeeks}`}</Text>
                        </Text>
                        <Text style={[styles.order_items.amount]}>
                            <Text>
                                {`${money(row.ItemTotal)}`}
                            </Text>
                        </Text>
                    </View>
                ))}
            </>
        )
    }

    const renderBalanceToMeetMinHireCharge = () => {
        return (
            <>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Balance to Meet Minimum Hire Charge ({money(Obj.details.min_hire)})</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.details.balance_to_meet_minimum_hire)}</Text>
                </View>
            </>
        )
    }

    const renderDamageWaiver = () => {
        return (
            <>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Slight Damage Waiver Fee**</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.charges.damage_fees)}</Text>
                </View>
            </>
        )
    }

    const Divider = () => <Text style={{ borderBottom: '1px solid #cec1c1', }} />

    const section_1 = () => {
        return (
            <>

                <View style={{ ...styles.rowLeft, }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Product Cost</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}> {money(calculateProductCosts(Obj?.order_items || [])?.subtotal || 0)}</Text>
                    {/* <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.details.SubTotal)}</Text> */}
                </View>
                {Obj?.details?.balance_to_meet_minimum_hire > 0 ? renderBalanceToMeetMinHireCharge() : null}
                {Obj?.charges?.damage_fees ? renderDamageWaiver() : null}
                <Divider />
            </>
        )
    }
    const section_2 = () => {
        return (
            <>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Subtotal</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.section_product_total)}</Text>
                </View>

                <View style={{ ...styles.rowLeft, width: '100%', backgroundColor: CARRIAGE_COL }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Carriage (See Breakdown)</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.section_transport_total)}</Text>
                </View>

                {(Obj?.charges?.HNS?.length || 0) > 0 ? <View style={{ ...styles.rowLeft, backgroundColor: HNS_COL }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Additional Costs (See Breakdown)</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.section_hns_total)}</Text>

                </View> : null}

                <Divider />



            </>
        )
    }

    const renderDeliveryCharges = () => {
        return (
            <>
                <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                    <Text style={[styles.order_items.left, styles.bold]}>Carriage Breakdown*</Text>
                </View>
                {(Obj?.charges?.delivery_cost && !Obj.details.Extension) || (Obj.details.Extension && Obj?.charges?.delivery_cost && Obj.charges?.delivery_cost != 0) ? (<Divider />) : null}

                {(Obj?.charges?.delivery_cost && !Obj.details.Extension) || (Obj.details.Extension && Obj?.charges?.delivery_cost && Obj.charges?.delivery_cost != 0) ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Standard Delivery
                            {!Obj?.charges?.del_option ?
                                (
                                    <>
                                        {!Obj?.charges?.del_option && Obj?.charges?.del_option_time_start ? ` (${dayjs(Obj.charges?.del_option_time_start, 'HH:mm').format('HH:mm')} - ` : ' (08:00 - '}
                                        {!Obj?.charges?.del_option && Obj?.charges?.del_option_time_start ? `${dayjs(Obj.charges?.del_option_time_end, 'HH:mm').format('HH:mm')})` : '18:00)'}
                                    </>
                                )
                                : null
                            }
                        </Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.delivery_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.weekend_delivery_cost ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Weekend Delivery</Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.weekend_delivery_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.del_option && Obj.charges.del_option ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        {Obj.charges.del_option_id.am != 'AM' && Obj.charges.del_option_id.pm != 'PM' ? (
                            <Text style={[styles.order_items.left]}>
                                {`Timed ${Obj.charges.del_option_id.duration}hr Slot (${dayjs(Obj.charges.del_option_id.start_time, 'HH:mm').format('HH:mm')} - ${dayjs(Obj.charges.del_option_id.end_time, 'HH:mm').format('HH:mm')}) ${capitalizeFirstLetter(Obj.charges.del_option_id.time)} Working Hours`}
                            </Text>
                        ) : (
                            <Text style={[styles.order_items.left]}>
                                {`Delivery Upgrade ${Obj.charges.del_option_id.pm != null ? Obj.charges.del_option_id.pm : Obj.charges.del_option_id.am} (${dayjs(Obj?.charges?.del_option_id.start_time, 'HH:mm').format('HH:mm')} - ${dayjs(Obj?.charges?.del_option_id.end_time, 'HH:mm').format('HH:mm')})`}
                            </Text>
                        )}
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.del_option_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.install && Obj.charges?.install_cost ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Install {mandatoryService && <Text style={{ color: 'red', fontWeight: 'bold', fontSize: 6 }}>(Mandatory)</Text>}</Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.install_cost)}</Text>
                    </View>
                ) : null}
            </>

        )
    }

    const renderCollectionCharges = () => {
        return (
            <>
                {(Obj?.charges?.collection_cost && !Obj.details.Extension) || (Obj.details.Extension && Obj?.charges?.collection_cost && Obj.charges?.collection_cost != 0) ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Standard Collection
                            {!Obj?.charges?.col_option ? (
                                <>
                                    {!Obj?.charges?.col_option && Obj?.charges?.col_option_time_start ? ` (${dayjs(Obj.charges?.col_option_time_start, 'HH:mm').format('HH:mm')} - ` : ' (08:00 - '}
                                    {!Obj?.charges?.col_option && Obj?.charges?.col_option_time_start ? `${dayjs(Obj.charges?.col_option_time_end, 'HH:mm').format('HH:mm')})` : '18:00)'}
                                </>
                            )
                                : null
                            }
                        </Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.collection_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.weekend_collection_cost ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Weekend Collection between 08:00 and 18:00</Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.weekend_collection_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.col_option && Obj.charges.col_option ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        {Obj.charges.col_option_id.am != 'AM' && Obj.charges.col_option_id.pm != 'PM' ? (
                            <Text style={[styles.order_items.left]}>
                                {`Timed ${Obj.charges.col_option_id.duration}hr Slot (${dayjs(Obj.charges.col_option_id.start_time, 'HH:mm').format('HH:mm')} - ${dayjs(Obj.charges.col_option_id.end_time, 'HH:mm').format('HH:mm')}) ${capitalizeFirstLetter(Obj.charges.col_option_id.time)} Working Hours`}
                            </Text>
                        ) : (
                            <Text style={[styles.order_items.left]}>
                                {`Collection Upgrade ${Obj.charges.col_option_id.pm != null ? Obj.charges.col_option_id.pm : Obj.charges.col_option_id.am} (${dayjs(Obj?.charges?.col_option_id.start_time, 'HH:mm').format('HH:mm')} - ${dayjs(Obj?.charges?.col_option_id.end_time, 'HH').format('HH:mm')})`}
                            </Text>
                        )}
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.col_option_cost)}</Text>
                    </View>
                ) : null}

                {Obj?.charges?.derig && Obj.charges?.derig_cost ? (
                    <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>Derig {mandatoryService && <Text style={{ color: 'red', fontWeight: 'bold', fontSize: 6 }}>(Mandatory)</Text>}</Text>
                        <Text style={[styles.order_items.right]}>{money(Obj.charges.derig_cost)}</Text>
                    </View>
                ) : null}

                <Divider />
            </>

        )
    }

    const renderHNS = () => {
        return (
            <>
                {(Obj?.charges?.HNS || []).map((HNS, idx) => (
                    <View key={idx} style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                        <Text style={[styles.order_items.left]}>{HNS.name}</Text>
                        <Text style={[styles.order_items.right]}>{money(HNS.price)}</Text>
                    </View>
                ))}

                {Obj.section_hns_total != 0 ? (
                    <>
                        <Divider />

                        <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                            <Text style={[styles.order_items.left]}></Text> {/* COLSPAN */}
                            <Text style={[styles.order_items.right]}>{money(Obj.section_hns_total)}</Text>
                        </View>
                    </>
                ) : null}

            </>
        )
    }

    const renderTableHeadingsTotals = () => {
        return (
            <>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>Total Cost (ex VAT) </Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.details.TotalCost)}</Text>
                </View>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg]}>VAT @ {Obj.details.VATAmount == null || Obj.details.VATAmount == 0 ? '0%' : '20%'}</Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.details.VATAmount)}</Text>
                </View>
                <View style={{ ...styles.rowLeft }}>
                    <Text style={[styles.order_items.left, styles.rowPaddimg, styles.bold]}>Total Cost (inc VAT) </Text>
                    <Text style={[styles.order_items.right, styles.rowPaddimg, styles.bold]}>{money(Obj.details.payment_amount)}</Text>
                </View>

                {
                    (type == 'order' && hasPartialPayment() == true) ? (
                        <>
                            <View style={{ ...styles.rowLeft }}>
                                <Text style={[styles.order_items.left, styles.rowPaddimg, styles.red]}>Less Payments (inc VAT) </Text>
                                <Text style={[styles.order_items.right, styles.rowPaddimg, styles.red]}>-{money(Obj.details.total_paid)}</Text>
                            </View>
                            <View style={{ ...styles.rowLeft }}>
                                <Text style={[styles.order_items.left, styles.rowPaddimg]}>Balance Due (inc VAT)</Text>
                                <Text style={[styles.order_items.right, styles.rowPaddimg]}>{money(Obj.details.payment_amount - Obj.details.total_paid)}</Text>
                            </View>
                        </>
                    ) : null
                }
            </>
        )
    }

    const footerString = () => {
        let str = "";

        str += `${BrandData?.CompanyName} is a trading name of ${BrandData?.CompanyNameOffice}, a company registered in England & Wales. Our company number is ${BrandData?.CompanyNumber}. Registered Office: ${BrandData?.RegisteredAddress1}, `
        if (isValidRow(BrandData.RegisteredAddressTown)) {
            str += `${BrandData.RegisteredAddressTown}, `;
        }
        if (isValidRow(BrandData.RegisteredAddressCounty)) {
            str += `${BrandData.RegisteredAddressCounty}, `;
        }
        str += `${BrandData.RegisteredAddressPostCode}. `;
        if (isValidRow(BrandData.VATRegistration)) {
            str += `VAT Registration Number: ${BrandData.VATRegistration}`
        }

        return str;
    }

    return (
        <Document title={`${type == 'order' && (is_proforma) ? 'Proforma ' : ''}${capitalizeFirstLetter(type)}-${Obj.details[capitalizeFirstLetter(type) + 'ID']}.pdf`}>
            <Page style={styles.body} size="A4">
                <View style={{ ...styles.content_top, height: '30px', margin: 0, padding: 0 }}>
                    <View style={{ margin: 0, padding: 0, height: '100%', width: '100%', }} >
                        <Text
                            style={{ ...styles.header, verticalAlign: 'top', margin: 0, marginTop: '-5px', padding: 0, float: 'left', textAlign: 'start', display: 'flex', justifyContent: 'flex-start', marginBottom: 'auto' }}>
                            {(is_proforma && type == 'order') ? 'Proforma ' : ''}
                            {Obj?.details?.Extension == 1 ? 'Extension ' : ''}
                            {type == 'order' ? `Invoice` : `Quote${QuoteLabel()}`}
                        </Text>
                    </View>
                    <View style={{ margin: 0, padding: 0, height: '100%', width: '100%' }} >
                        <Image
                            style={{ ...styles.image, margin: 0, padding: 0, float: 'right', textAlign: 'end', display: 'flex', justifyContent: 'flex-end', marginLeft: 'auto' }}
                            src={`${hide_product_images ? process.env.NEXT_PUBLIC_HOME_URL : ''}/images/${Obj.details.Brand}/logo-main.png`}
                        />
                    </View>
                </View>


                {/* Invoice and company info */}
                <View style={{ ...styles.content, marginTop: '4px' }}>
                    <View style={{ ...styles.block, width: '100%' }}>
                        {invoiceTable()}
                    </View>

                    <View style={{ ...styles.block, width: '100%', textAlign: 'right', float: 'right' }}>
                        <Text style={styles.bold}>{BrandData.CompanyName}</Text>
                        <Text>{BrandData.Address1}</Text>
                        <Text>{BrandData.AddressTown}, {BrandData.AddressPostCode}</Text>
                        <Text>{BrandData.Telephone}</Text>
                        <Text>{BrandData.AccountsEmail}</Text>
                    </View>
                </View>
                {/* Invoice and company info */}


                {/* Bill to details */}
                {billToTable()}
                {/* Bill to details */}

                {
                    (Obj?.details?.Extension == 0 && Obj?.details?.StartDate && Obj?.details?.EndDate) ||
                        (Obj?.details?.Extension == 1 && Obj?.details?.StartDate && Obj?.details?.EndDate && Obj?.order_items && count(Obj.order_items) != 0) ? (
                        <View style={{ marginTop: '10px' }}>
                            <Text>
                                Your hire period is <Text style={[styles.bold]}>{dayjs(Obj.details.StartDate).format('dddd, Do MMMM YYYY')}</Text> to <Text style={[styles.bold]}>{dayjs(Obj.details.EndDate).format('dddd, Do MMMM YYYY')}</Text>.
                            </Text>
                        </View>
                    ) : null
                }

                {/* Table */}
                <View style={{ ...styles.content, width: '100%', marginTop: '10px' }}>

                    <View style={{ ...styles.table, paddingRight: 8 }}>
                        {renderTableHeadings()}

                        {count(Obj.order_items) != 0 ? <Divider /> : null}
                        {renderTableProducts()}
                        <Divider />
                        {/* {Obj?.details?.balance_to_meet_minimum_hire > 0 ? renderBalanceToMeetMinHireCharge() : null} 
                            // {Obj?.charges?.damage_fees ? renderDamageWaiver() : null}
                            {renderDeliveryCharges()}
                            {renderCollectionCharges()}
                            {Obj?.charges?.HNS && count(Obj.charges.HNS) > 0 ? renderHNS() : null} */}
                    </View>
                </View>
                {/* Table */}

                <View style={{ ...styles.content, marginTop: '25px' }}>
                    <View style={{ ...styles.table, paddingRight: 8 }}>
                        <View style={{ backgroundColor: BrandData.breakdown_hex, borderRadius: '8px', paddingTop: '2px' }}>
                            {renderDeliveryCharges()}
                            {renderCollectionCharges()}
                            <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                                <Text style={[styles.order_items.left]}></Text> {/* COLSPAN */}
                                <Text style={[styles.order_items.right]}>{money(Obj.section_transport_total)}</Text>
                            </View>
                            {/* <Divider/> */}
                        </View>

                        {(Obj?.charges?.HNS?.length || 0) > 0 ? <View style={{ backgroundColor: HNS_COL, borderRadius: '8px', marginTop: '4px' }}>
                            <View style={{ ...styles.rowLeft, ...styles.rowPaddimg }}>
                                <Text style={[styles.order_items.left, styles.bold]}>Additional Costs</Text>
                            </View>
                            <Divider />
                            {renderHNS()}
                        </View> : null}
                    </View>

                    <View style={{ ...styles.table, borderRadius: '8px', border: '1px solid grey' /*backgroundColor: BrandData.breakdown_hex*/ }}>
                        {section_1()}
                        {section_2()}
                        {renderTableHeadingsTotals()}
                    </View>


                </View>


                {/* Totals */}
                {/* <View style={{...styles.content_top, marginTop: '8px', marginBottom: '8px'}}>
                    <View style={{...styles.block}}>
                    </View>
               
                </View> */}
                {/* Totals */}



                {
                    Obj?.details?.delivery_comments && Obj.details.delivery_comments != null && Obj.details.delivery_comments != "" ? (
                        <View style={{ ...styles.content, fontSize: 8, marginTop: '2px' }}>
                            <View style={{ ...styles.block }} >
                                <Text style={[styles.bold]}>Delivery Comments:</Text>
                                <Text style={{ marginTop: '2px' }}>{Obj.details.delivery_comments}</Text>
                            </View>
                        </View>
                    ) : null
                }
                {
                    Obj?.details?.collection_comments && Obj.details.collection_comments != null && Obj.details.collection_comments != "" ? (
                        <View style={{ ...styles.content, fontSize: 8, marginTop: '2px' }}>
                            <View style={{ ...styles.block }} >
                                <Text style={[styles.bold]}>Collection Comments:</Text>
                                <Text style={{ marginTop: '2px' }}>{Obj.details.collection_comments}</Text>
                            </View>
                        </View>
                    ) : null
                }
                {
                    Obj?.details?.general_comments && Obj.details.general_comments != null && Obj.details.general_comments != "" ? (
                        <View style={{ ...styles.content, fontSize: 8, marginTop: '2px' }}>
                            <View style={{ ...styles.block }} >
                                <Text style={[styles.bold]}>General Comments:</Text>
                                <Text style={{ marginTop: '2px' }}>{Obj.details.general_comments}</Text>
                            </View>
                        </View>
                    ) : null
                }

                {(type == 'quote' && existing && Obj?.details?.QuoteStatus == 'OUTSTANDING') ?
                    (
                        <>
                            {
                                isDefined(process.env.NEXT_PUBLIC_HIRELOGISTICS_URL) && (
                                    <View style={{ ...styles.content, marginTop: '8px' }}>
                                        <View style={styles.block}>

                                            <Link target="_blank" style={styles.link} src={`${process.env.NEXT_PUBLIC_HIRELOGISTICS_URL}actions/confirm-quote?quote_id=${Obj?.details[`${capitalizeFirstLetter(type)}ID`]}&pword=${Obj.details.PWord}`}>
                                                <Text style={{ ...styles.bold, fontSize: 12 }}>
                                                    {
                                                        Obj?.details[`${capitalizeFirstLetter(type)}ID`] ?
                                                            'Accept & Pay Online' : 'Pay Online'
                                                    }
                                                </Text>
                                            </Link>
                                        </View>
                                    </View>
                                )
                            }

                            {/* Bank details */}
                            <View style={{ ...styles.content, marginTop: '8px' }}>
                                <View style={{ ...styles.block, width: '100%' }}>
                                    {renderBankDetails()}
                                </View>
                            </View>
                            {/* Bank details */}
                        </>

                    ) : type == 'order' && Obj?.details?.PaymentReceived == 0 ? (
                        <>
                            {
                                isDefined(process.env.NEXT_PUBLIC_HIRELOGISTICS_URL) && (
                                    <View style={{ ...styles.content, marginTop: '8px' }}>
                                        <View style={styles.block}>

                                            <Link style={styles.link} src={`${process.env.NEXT_PUBLIC_HIRELOGISTICS_URL}actions/order-payment?customer_id=${Obj.details.CustomerID}&brand=${Obj.details.Brand}&pword=${Obj.details.customer_password}`}>
                                                <Text style={{ ...styles.bold, fontSize: 12 }}>
                                                    {
                                                        'Pay Online'
                                                    }
                                                </Text>
                                            </Link>
                                        </View>
                                    </View>
                                )
                            }

                            {/* Bank details */}
                            <View style={{ ...styles.content, marginTop: '8px' }}>
                                <View style={{ ...styles.block, width: '100%' }}>
                                    {renderBankDetails()}
                                </View>
                            </View>
                            {/* Bank details */}
                        </>
                    ) : null
                }

                {is_proforma == true && type == 'order' ? (
                    <View style={{ ...styles.content, fontSize: 8, marginTop: '4px' }}>
                        <View style={{ ...styles.block }} >
                            <Text style={[styles.bold]}>Please note: <Text style={{ color: 'red' }}>THIS IS NOT A VAT INVOICE.</Text></Text>
                        </View>
                    </View>
                ) : null}

                <View style={{ ...styles.content, fontSize: 8, marginTop: '4px' }}>
                    <View style={{ ...styles.block }} >
                        <Text>*Unless stated/agreed otherwise, our standard delivery and collection service is to a single point on a ground floor or loading bay.
                            Install/set-up and derig/take-down services are not included as standard.
                        </Text>
                    </View>
                </View>

                <View style={{ ...styles.content, fontSize: 8, marginTop: '4px' }}>
                    <View style={{ ...styles.block }} >
                        <Text>**The damage waiver fee covers reasonable wear and tear. The customer is accountable for damage beyond this.</Text>
                    </View>
                </View>
                <View style={{ ...styles.content, fontSize: 8, marginTop: '4px' }}>
                    <View style={{ ...styles.block }} >
                        <Text>Note: {footerString()}</Text>

                    </View>
                </View>
                {/* 
                <View style={{
                        ...styles.content, 
                        position: 'absolute', 
                        bottom: '6%', 
                        fontSize: 8,
                        paddingRight: '16px',
                        paddingLeft: '28px',
                    }}
                >
                    <View style={{...styles.block}} >
                        <Text>
                            {footerString()}
                        </Text>
                    </View>
                </View> */}

                <View style={{
                    ...styles.content,
                    paddingRight: '16px',
                    paddingLeft: '28px',
                    paddingBottom: '10px',
                    paddingTop: '2px',
                    position: 'absolute',
                    bottom: 0
                }} render={({ pageNumber, totalPages }) => (

                    <>
                        <View style={{ ...styles.block, textAlign: 'left' }}>
                            <Text style={{ fontSize: 8 }}>
                                {`${type == 'order' ? 'Invoice' : 'Quote'} Reference `}
                                {`${Obj.details[`${capitalizeFirstLetter(type)}ID`] == '' || Obj.details[`${capitalizeFirstLetter(type)}ID`] == 'XXXXX' ? 'N/A' : Obj.details[`${capitalizeFirstLetter(type)}ID`]}`}
                            </Text>
                        </View>
                        <View style={{ textAlign: 'right' }}>
                            <Text style={{ fontSize: 8 }}>{`Page ${pageNumber} of ${totalPages}`}</Text>
                        </View>
                    </>
                )
                } fixed />

            </Page>
        </Document>
    )
}

export default QuotePDFDoc;